import * as React from 'react';
import { formatCapitalized } from 'src/share/utils/utils';
import { Checkbox } from 'src/share/components/Checkbox/Checkbox';
import { Col } from 'reactstrap';
import { IChild } from 'src/share/types/case/children';
import { IChildrenSelector } from 'src/modules/Alert/Create/types';

export interface IChildOptionsProps {
  isEdit: boolean;
  childrenSelector: IChildrenSelector
  child: IChild
  switchHandler: (childId: string) => any
  getImage: (childId: string, image: string, showNoImage?: boolean) => JSX.Element | null
}

export const ChildOptions = ({ child, isEdit, childrenSelector, switchHandler, getImage }: IChildOptionsProps) => {
  const { childId, images, fullName } = child;
  const [portrait = "", alternate = "", progressed = ""] = images || []
  const childSelected = childrenSelector[childId]
  const shouldShow = isEdit && childSelected && childSelected.selected || !isEdit
  const name = formatCapitalized(fullName);
  return shouldShow ? (
    <Col key={childId} className={`col-12 child-container`}>
      {isEdit && <p>{name}</p>}
      {!isEdit && <Checkbox disabled={false} label={name} {...switchHandler(childId)} />}
      <div className="child-background">
        {getImage(childId, portrait, true)}
        {getImage(childId, alternate)}
        {getImage(childId, progressed)}
      </div>
    </Col>
  ) : null
}



// WEBPACK FOOTER //
// ./src/modules/Alert/ChildrenForm/components/ChildOptions.tsx